import { Link } from "react-router-dom";
import { SERVICES, SERVICE_GROUPS, CITIES } from "@/data/seoPages";

// SEO mega-footer: internal links to every service + city landing page.
export function SeoFooter() {
  const provinces = [...new Set(CITIES.map((c) => c.province))];

  return (
    <section className="border-t border-border bg-background blueprint-grid-fine" data-testid="seo-footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-14">
        {/* Services */}
        <div className="mb-12">
          <div className="flex items-baseline justify-between mb-6">
            <h2 className="font-mono-tech text-xs tracking-widest uppercase text-primary">Services we offer</h2>
            <Link to="/services" className="font-mono-tech text-[11px] tracking-widest uppercase text-muted-foreground hover:text-primary" data-testid="seo-all-services">
              All services →
            </Link>
          </div>
          <div className="grid lg:grid-cols-[2fr_1fr] gap-x-8 gap-y-8">
            {SERVICE_GROUPS.map((group) => (
              <div key={group}>
                <h3 className="font-display uppercase tracking-tight text-sm text-muted-foreground mb-3">{group}</h3>
                <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2">
                  {SERVICES.filter((s) => s.group === group).map((s) => (
                    <li key={s.slug}>
                      <Link to={`/services/${s.slug}`} data-testid={`seo-service-${s.slug}`} className="text-sm text-foreground/80 hover:text-primary transition-colors">
                        {s.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Locations */}
        <div>
          <div className="flex items-baseline justify-between mb-6">
            <h2 className="font-mono-tech text-xs tracking-widest uppercase text-primary">Locations across Canada</h2>
            <Link to="/locations" className="font-mono-tech text-[11px] tracking-widest uppercase text-muted-foreground hover:text-primary" data-testid="seo-all-locations">
              All locations →
            </Link>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-6">
            {provinces.map((prov) => (
              <div key={prov}>
                <h3 className="font-display uppercase tracking-tight text-sm text-muted-foreground mb-3">{prov}</h3>
                <ul className="flex flex-wrap gap-x-3 gap-y-2">
                  {CITIES.filter((c) => c.province === prov).map((c) => (
                    <li key={c.slug}>
                      <Link to={`/locations/${c.slug}`} data-testid={`seo-city-${c.slug}`} className="text-sm text-foreground/80 hover:text-primary transition-colors">
                        {c.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
